'use strict';

import Model from './model.js';
import Log from 'lib/log';
const log = Log('newModels/payslip-detail');

export default class PayslipDetail extends Model {
    urlRoot() { return '/PayslipDetails'; }

    initialize() {
        this.payrollItem = this.getPayrollItem();
        this.affectsItem = this.getAffectsItem();
        this.on('change:payrollItemId', this._setPayrollItem, this);
        this.on('change:affectsItem', this._setAffectsItem, this);
        this.idAttribute = 'objectId';
        return super.initialize(...arguments);
    }

    getPayrollItem() {
        if (this.payrollItem) {
            return this.payrollItem;
        }

        return this._setPayrollItem(this.get('payrollItemId'));
    }

    _setPayrollItem(id) {
        if (!app.payrollItems) {
            log.warn(`App hasn't any payroll items loaded`);
            return;
        }

        if (!id) {
            log.warn(`PayslipDetail doesn't have a payroll item`);
            return;
        }

        this.payrollItem = app.payrollItems.find(model => {
            return model.get('objectId') === id;
        });

        return this.payrollItem;
    }

    getAffectsItem() {
        if (this.affectsItem) {
            return this.affectsItem;
        }

        return this._setAffectsItem(this.get('affectsItemId'));
    }

    _setAffectsItem(id) {
        if (!app.payrollItems) {
            log.warn(`App hasn't any payroll items loaded`);
            return;
        }

        if (!id) {
            return;
        }

        this.affectsItem = app.payrollItems.find(model => {
            return model.get('objectId') === id;
        });

        return this.affectsItem;
    }

    isUnit() {
        const item = this.getPayrollItem();
        return item.get('isUnit') === true;
    }

    isZakat() {
        const item = this.getPayrollItem();
        return item.get('type') === 'zakat';
    }

    isAddition() {
        const item = this.getPayrollItem();
        return (
            item &&
            _.contains(
                ['addition', 'bonus', 'base'],
                item.get('type')
            ) &&
            (item.get('isGross') || item.get('isNet'))
        );
    }

    isDeduction() {
        const item = this.getPayrollItem();
        return (
            item &&
            _.contains(
                [
                    'unpaid_leave', 'deduction', 'mtd', 'epf', 'socso',
                    'cp38'
                ],
                item.get('type')
            ) &&
            (item.get('isGross') || item.get('isNet'))
        );
    }

    isOther() {
        const item = this.getPayrollItem();
        return (
            item &&
            !item.get('isGross') &&
            !item.get('isNet')
        );
    }

    getRealAmount() {
        const item = this.getPayrollItem();
        const multiplier = (
            _.contains(
                ['base', 'bonus', 'addition', 'benefit', 'overtime'],
                item.get('type')
            ) ? 1 : -1
        );
        return ((this.get('amount') || 0) * multiplier);
    }

    getPayrollItemName() {
        let payrollItemName = (
            this.getPayrollItem() ?
                this.getPayrollItem().get('name') : ''
        ) || '';

        if (this.getAffectsItem() && this.getAffectsItem().get('name')) {
            payrollItemName += ' on ' + this.getAffectsItem().get('name');
        }

        return payrollItemName;
    }
}



// WEBPACK FOOTER //
// ./app/new-models/payslip-detail.js